export default "__VITE_ASSET__BES_k6M5__"